/**
 * Public URL prefix of the frontend. Empty for root deployments, e.g. "/skola"
 * when Knozi is mounted below knozi.cz/skola.
 */
export const APP_BASE_PATH = process.env.NEXT_PUBLIC_APP_BASE_PATH ?? "";

/** Prefix an application-relative URL when using a sub-path deployment. */
export const withAppBasePath = (path: string): string => {
  if (/^(?:[a-z]+:)?\/\//i.test(path)) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!APP_BASE_PATH) return normalized;
  if (normalized === APP_BASE_PATH || normalized.startsWith(`${APP_BASE_PATH}/`) || normalized.startsWith(`${APP_BASE_PATH}?`) || normalized.startsWith(`${APP_BASE_PATH}#`)) {
    return normalized;
  }
  return `${APP_BASE_PATH}${normalized}`;
};

/** Convert a browser pathname back to the path expected by Next's router. */
export const stripAppBasePath = (path: string): string => {
  if (!APP_BASE_PATH) return path;
  if (path === APP_BASE_PATH) return "/";
  if (path.startsWith(`${APP_BASE_PATH}?`) || path.startsWith(`${APP_BASE_PATH}#`)) return `/${path.slice(APP_BASE_PATH.length)}`;
  if (path.startsWith(`${APP_BASE_PATH}/`)) {
    return path.slice(APP_BASE_PATH.length) || "/";
  }
  return path;
};

/** Frontend never knows backend URL. All API calls go via the Next.js proxy. */
export const API_BASE_PATH = withAppBasePath("/api");

export const AUTH_DEBUG = process.env.NEXT_PUBLIC_AUTH_DEBUG === "1";
export const ENABLE_RBAC_TELEMETRY_CLIENT =
  process.env.NEXT_PUBLIC_ENABLE_RBAC_TELEMETRY_CLIENT === "1";


/** Google Identity Services login. Public client ID only; no client secret is exposed. */
export const GOOGLE_SSO_ENABLED_CLIENT =
  process.env.NEXT_PUBLIC_GOOGLE_SSO_ENABLED === "true";
export const GOOGLE_SSO_CLIENT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "";
